module.exports = {
    versionCheck: '4DT8GBYwVwddu3gUR',
    site: window.location.protocol + '//' + window.location.host,
    unrestrictedRoutes: ['faq', 'SMSterms']
};




// WEBPACK FOOTER //
// ./app/scripts/constants/application.js